/* global nienhuys */

import eventBus from "../utils/eventBus";

const getCallback = async () => {
  const { nienhuys } = window;

  const formData = new FormData();
  formData.append('action', 'getCallbackSlots');
  formData.append('nonce',  nienhuys.nonce);

  let response = await fetch(nienhuys.ajaxurl, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

const callbackDates = document.querySelector('[data-callback-dates]');
const callbackTimeslots = document.querySelector('[data-callback-timeslots]');

if(callbackDates && callbackTimeslots) {
  const slots = getCallback();

  const callbackDateWrapper = callbackDates.querySelector('.wpcf7-form-control');
  const callbackDateTpl = callbackDates.querySelector('.wpcf7-list-item');
  callbackDateWrapper.innerHTML = '';

  const callbackTimeslotWrapper = callbackTimeslots.querySelector('.wpcf7-form-control');
  const callbackTimeslotTpl = callbackTimeslots.querySelector('.wpcf7-list-item');
  callbackTimeslotWrapper.innerHTML = '';


  slots.then(res => {

    let i = 0;
    let first = true;
    Object.entries(res.data.dates).forEach(date => {

      const [key, value] = date;

      const input = callbackDateTpl.cloneNode(true);
      input.querySelector('.wpcf7-list-item-label').innerHTML = value.date_formatted;
      input.querySelector('.wpcf7-list-item-label').dataset.timeSlots = JSON.stringify(value.slots);
      input.querySelector('input').value = value.date;

      if(i !== 0) {
        input.querySelector('input').checked = false;
      }

      input.addEventListener('click', () => {
        if(!input.querySelector('input').checked) {
          callbackTimeslotWrapper.innerHTML = '';
          const dateSlots = JSON.parse(input.querySelector('.wpcf7-list-item-label').dataset.timeSlots);
          Object.entries(dateSlots).forEach(dateSlot => {
            const [dateSlotKey, dateSlotValue] = dateSlot;

            const timeInput = callbackTimeslotTpl.cloneNode(true);
            timeInput.querySelector('.wpcf7-list-item-label').innerHTML = dateSlotValue.label;
            timeInput.querySelector('input').value = dateSlotValue.from;
            timeInput.querySelector('input').checked = false;

            callbackTimeslotWrapper.appendChild(timeInput);
          });
        }
      });

      callbackDateWrapper.appendChild(input);

      i++;

      if(first) {
        first = false;
        Object.entries(value.slots).forEach(slot => {
          const [slotKey, slotValue] = slot;

          const input = callbackTimeslotTpl.cloneNode(true);
          input.querySelector('.wpcf7-list-item-label').innerHTML = slotValue.label;
          input.querySelector('input').value = slotValue.from;
          input.querySelector('input').checked = false;

          callbackTimeslotWrapper.appendChild(input);
        });
      }

    });

    // # TODO: Click action to load slots by day

  });
}

export default getCallback;
